import { useMemo, useState } from 'react';

const useTrimmedKeyword = (defaultValue = '') => {
  const [keyword, setKeyword] = useState(defaultValue);

  const trimmedKeywordInView = useMemo(
    () => keyword.replace(/ +(?= )/g, '').trimStart(),
    [keyword]
  );
  const trimmedKeywordDependency = useMemo(
    () => trimmedKeywordInView.trim(),
    [trimmedKeywordInView]
  );

  return [trimmedKeywordInView, setKeyword, trimmedKeywordDependency];
};

export default useTrimmedKeyword;
